/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_Status_Edit_AllInputs */

const en_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publishing edit results for all tracks.`)
};

const fr_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication des résultats d’édition pour toutes les pistes.`)
};

const de_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlichungsergebnisse für alle Titel.`)
};

const it_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblicazione dei risultati delle modifiche per tutte le tracce.`)
};

const ru_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Публикация результатов редактирования для всех треков.`)
};

const es_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación de resultados de edición para todas las pistas.`)
};

const zh_cn2_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`发布所有曲目的编辑结果。`)
};

const ja_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべてのトラックの編集結果を公開します。`)
};

const hi_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी ट्रैक के लिए संपादन परिणाम प्रकाशित किए जा रहे हैं।`)
};

const pt_pt2_work_order_publish_status_edit_all = /** @type {(inputs: Work_Order_Publish_Status_Edit_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicando os resultados da edição para todas as faixas.`)
};

/**
* | output |
* | --- |
* | "Publishing edit results for all tracks." |
*
* @param {Work_Order_Publish_Status_Edit_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_status_edit_all = /** @type {((inputs?: Work_Order_Publish_Status_Edit_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_Status_Edit_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_work_order_publish_status_edit_all(inputs)
	if (locale === "de") return de_work_order_publish_status_edit_all(inputs)
	if (locale === "it") return it_work_order_publish_status_edit_all(inputs)
	if (locale === "ru") return ru_work_order_publish_status_edit_all(inputs)
	if (locale === "es") return es_work_order_publish_status_edit_all(inputs)
	if (locale === "zh-CN") return zh_cn2_work_order_publish_status_edit_all(inputs)
	if (locale === "ja") return ja_work_order_publish_status_edit_all(inputs)
	if (locale === "hi") return hi_work_order_publish_status_edit_all(inputs)
	if (locale === "pt-PT") return pt_pt2_work_order_publish_status_edit_all(inputs)
	return en_work_order_publish_status_edit_all(inputs)
});